import { render, staticRenderFns } from "./CardBarChart.vue?vue&type=template&id=cbb6c0c2"
import script from "./CardBarChart.vue?vue&type=script&lang=js"
export * from "./CardBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports